import { Col, Row } from 'react-bootstrap';
import ActionRequestsCard from './components/Cards/ActionRequestsCard/ActionRequestsCard';
import AdditionalSettingsCard from './components/Cards/AdditionalSettingsCard/AdditionalSettingsCard';
import AdvancedSettingsCard from './components/Cards/AdvancedSettingsCard/AdvancedSettingsCard';
import ImagingModesCard from './components/Cards/ImagingModesCard/ImagingModesCard';
import ModesCard from './components/Cards/ModesCard/ModesCard';
import ThresholdSettingsCard from './components/Cards/ThresholdSettingsCard/ThresholdSettingsCard';

export default function FloodDeviceSettingsForm({
  deviceSettings,
  setDeviceSettings,
  handleInputChange,
  device,
  enabled,
}) {
  return (
    <Row className="gy-4 mt-1">
      <Col lg={6} className="d-flex flex-column gap-4">
        {/* Depth / rise-rate / drop-rate thresholds */}
        <ThresholdSettingsCard
          deviceSettings={deviceSettings}
          handleInputChange={handleInputChange}
          device={device}
          enabled={enabled}
        />
        {/* Reporting and sampling mode selection */}
        <ModesCard
          deviceSettings={deviceSettings}
          setDeviceSettings={setDeviceSettings}
          enabled={enabled}
        />
        {/* Toggles for each imaging trigger type */}
        <ImagingModesCard
          deviceSettings={deviceSettings}
          setDeviceSettings={setDeviceSettings}
          device={device}
          enabled={enabled}
        />
      </Col>

      <Col lg={6} className="d-flex flex-column gap-4">
        {/* External device, imaging holdoff window, water-level adjustment */}
        <AdditionalSettingsCard
          deviceSettings={deviceSettings}
          setDeviceSettings={setDeviceSettings}
          device={device}
          enabled={enabled}
        />
        {/* One-shot actions sent with the next command */}
        <ActionRequestsCard
          deviceSettings={deviceSettings}
          setDeviceSettings={setDeviceSettings}
          device={device}
          enabled={enabled}
        />
        {/* Destination IP / port / reboot — modify only with support guidance */}
        <AdvancedSettingsCard
          deviceSettings={deviceSettings}
          setDeviceSettings={setDeviceSettings}
          enabled={enabled}
        />
      </Col>
    </Row>
  );
}
